module.exports = __webpack_public_path__ + "media/images/camera-ca14e255a0de928aea1777748d777115.jpeg";